<template>
  <div class="modal-clone-module p-5">
    <strong>
      Copiar módulo existente
    </strong>
    <action-dispatcher
      action="product/get"
      class="my-5"
      :parameters="{ limit: 100 }"
    >
      <form-group
        select
        id="product-select"
        :options="products"
        label="Selecione o produto"
        placeholder="Selecione o produto..."
        v-model="product_id"
      />
    </action-dispatcher>
    <action-dispatcher
      v-if="product_id"
      :key="product_id"
      action="membersModules/get"
      :parameters="{ product_id, commit: false, limit: 50 }"
      @success="setModules"
    >
      <form-group
        select
        id="module-select"
        label="Selecione o módulo"
        placeholder="Selecione o módulo..."
        v-model="module_id"
        :options="modules"
      />
    </action-dispatcher>

    <div class="mt-6 row">
      <div class="col-lg-6 order-lg-1">
        <button
          class="btn btn-block"
          :disabled="!isValid"
          :class="isValid ? 'btn-primary' : 'btn-secondary'"
          @click="submit"
        >
          <loading :show="loading">Confirmar</loading>
        </button>
      </div>
      <div class="col-lg-6">
        <button
          class="btn btn-outline-secondary btn-block"
          @click="$emit('close')"
        >
          Cancelar
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      loading: false,
      product_id: "",
      module_id: "",
      modules: []
    };
  },
  computed: {
    ...mapState("product", ["products"]),
    isValid() {
      return this.product_id && this.module_id;
    }
  },
  methods: {
    submit() {
      this.loading = true;
      this.$store
        .dispatch("membersModules/clone", {
          target_product: this.$route.params.id,
          module_id: this.module_id
        })
        .then(() => {
          this.$emit("close");
          this.$emit("refresh");
          this.$message.success("Módulo copiado.");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setModules(v) {
      this.modules = v.data.results;
    }
  },
  watch: {
    product_id() {
      this.module_id = "";
    }
  }
};
</script>
